import { MuiMenu } from "./MuiMenu";
import { MuiButton } from "./MuiButton";
import { MuiChip } from "./MuiChip";
import { MuiDialog } from "./MuiDialog";
import { MuiTable } from "./MuiTable";
import { MuiTableRow } from "./MuiTableRow";
import { MuiTableCell } from "./MuiTableCell";
import { MuiIconButton } from "./MuiIconButton";
import { MuiCard } from "./MuiCard";
import { MuiTab } from "./MuiTab";
import { MuiCardContent } from "./MuiCardContent";
import { MuiCardHeader } from "./MuiCardHeader";
import { MuiTextField } from "./MuiTextField";
import { MuiFormControl } from "./MuiFormControl";
import { MuiInput } from "./MuiInput";
import { MuiAccordion } from "./MuiAccordion";
import { MuiFormControlLabel } from "./MuiFormControlLabel";
import { MuiFormLabel } from "./MuiFormLabel";
import { MuiSelect } from "./MuiSelect";

import { Components, Theme } from "@mui/material";

export const components: Components<Theme> = {
  MuiButton,
  MuiChip,
  MuiMenu,
  MuiDialog,
  MuiTable,
  MuiTableRow,
  MuiTableCell,
  MuiIconButton,
  MuiCard,
  MuiTab,
  MuiCardContent,
  MuiCardHeader,
  MuiTextField,
  MuiFormControl,
  MuiInput,
  MuiAccordion,
  MuiFormControlLabel,
  MuiFormLabel,
  MuiSelect,
};

export * from "./palette";
export * from "./typography";
